module.exports = __webpack_public_path__ + "img/commercial-back-1.2acd393d.jpg";